import { all, takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import { ENDPOINT_PRODUTOS } from '~/config/constants';
import { Types, loadProdutosSuccess, loadProdutosFailure } from './actions';
import { Types as TypesPerguntas } from '../perguntas/actions';
import api from '../../../config/axios';
import { toggleLoading } from '~/store/modules/loading/actions';

export function* loadProdutos() {
  try {
    yield put(toggleLoading(true));
    const { data } = yield call(api.get, ENDPOINT_PRODUTOS);
    yield put(loadProdutosSuccess(data));
  } catch (e) {
    yield put(loadProdutosFailure());
  } finally {
    yield put(toggleLoading(false));
  }
}

export default all([
  takeLatest(Types.REQUEST, loadProdutos),
  takeEvery(TypesPerguntas.REQUEST, loadProdutos),
]);
